import '@adornis/bh-matching-config/entities/global-config.js';
import '@adornis/bh-matching-export/db/BuddyExportDataView.js';
import '@adornis/bh-matching-mails/entities/attachment.js';
import '@adornis/bh-matching-mails/entities/mail-templates.js';
import '@adornis/bh-matching-matches/api/matchAPI.js';
import '@adornis/bh-matching-matches/entities/match.js';
import { setUserClass } from '@adornis/bh-matching-matches/user-class.js';
import '@adornis/bh-matching-timeframes/api/MatchingTimeframeAPI.js';
import '@adornis/bh-matching-user/api/MatchingUserAPI.js';
import '@adornis/bh-matching-user/api/registerAdminUser.js';
import '@adornis/bh-matching-user/entities/buddy-user.js';
import '@adornis/bh-timeframes/api/TimeframeAPI.js';
import '@adornis/file-utils/db/index.js';
import '@adornis/users/db/a-user.js';
import { AccompanyingBuddyFfmUser, BuddyFfmUser } from '../entities/buddy-ffm-users.js';

setUserClass({
  mentee: BuddyFfmUser,
  mentor: AccompanyingBuddyFfmUser,
});
